module.exports = __webpack_public_path__ + "img/8.817e5fca.png";